/**
 * @copyright Copyright (c) 2021 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author Christopher Ng <chrng8@gmail.com>
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */

import { getCurrentUser } from '@nextcloud/auth'
import { Type as ShareType } from '@nextcloud/sharing'

import DownloadLimitEntry from '../components/DownloadLimitEntry.vue'

interface ActionData {
	share: any, // eslint-disable-line @typescript-eslint/no-explicit-any
	fileInfo: any, // eslint-disable-line @typescript-eslint/no-explicit-any
	[key: string]: unknown,
}

export class DownloadLimitAction {

	get id() {
		return 'files_downloadlimit'
	}

	get shareType() {
		return [
			ShareType.SHARE_TYPE_LINK,
			ShareType.SHARE_TYPE_EMAIL,
		]
	}

	data({ share, fileInfo }: ActionData) {
		// Only works for files and existing shares
		if (typeof share.token !== 'string' || fileInfo.type !== 'file' || share.owner !== getCurrentUser()?.uid) {
			return {}
		}

		return {
			is: DownloadLimitEntry,
			share,
		}
	}

	get advanced() {
		return true
	}

	get handlers() {
		return {}
	}

}
